import { Integration } from 'admin-panel/constants';
import { apaleo } from 'admin-panel/utils/integrations/service-forms/apaleo';
import { asa } from 'admin-panel/utils/integrations/service-forms/asa';
import { duve } from 'admin-panel/utils/integrations/service-forms/duve';
import { fias } from 'admin-panel/utils/integrations/service-forms/fias';
import { guestline } from 'admin-panel/utils/integrations/service-forms/guestline';
import { hotelkit } from 'admin-panel/utils/integrations/service-forms/hotelkit';
import { hotsoft } from 'admin-panel/utils/integrations/service-forms/hotsoft';
import { infor } from 'admin-panel/utils/integrations/service-forms/infor';
import { maxxton } from 'admin-panel/utils/integrations/service-forms/maxxton';
import { mews } from 'admin-panel/utils/integrations/service-forms/mews';
import { ohip } from 'admin-panel/utils/integrations/service-forms/ohip';
import { protel } from 'admin-panel/utils/integrations/service-forms/protel';
import { shiji } from 'admin-panel/utils/integrations/service-forms/shiji';
import { sihot } from 'admin-panel/utils/integrations/service-forms/sihot';
import { simphonyGen1 } from 'admin-panel/utils/integrations/service-forms/simphony-gen1';
import { simphonyGen2 } from 'admin-panel/utils/integrations/service-forms/simphony-gen2';
import { stayntouch } from 'admin-panel/utils/integrations/service-forms/stayntouch';
import { suite8 } from 'admin-panel/utils/integrations/service-forms/suite8';
import { unifocus } from 'admin-panel/utils/integrations/service-forms/unifocus';

import type { ServiceFormDefinition } from 'admin-panel/utils/integrations/types';

export const SERVICE_FORMS: Record<Integration, ServiceFormDefinition> = {
  [Integration.Apaleo]: apaleo,
  [Integration.Asa]: asa,
  [Integration.Duve]: duve,
  [Integration.Fias]: fias,
  [Integration.Guestline]: guestline,
  [Integration.Hotelkit]: hotelkit,
  [Integration.Hotsoft]: hotsoft,
  [Integration.Infor]: infor,
  [Integration.Maxxton]: maxxton,
  [Integration.Mews]: mews,
  [Integration.Ohip]: ohip,
  [Integration.Protel]: protel,
  [Integration.Shiji]: shiji,
  [Integration.Sihot]: sihot,
  [Integration.SimphonyGen1]: simphonyGen1,
  [Integration.SimphonyGen2]: simphonyGen2,
  [Integration.Stayntouch]: stayntouch,
  [Integration.Suite8]: suite8,
  [Integration.Unifocus]: unifocus,
};

export const serviceFormFor = (
  serviceName: string
): ServiceFormDefinition | undefined =>
  Object.hasOwn(SERVICE_FORMS, serviceName)
    ? SERVICE_FORMS[serviceName as Integration]
    : undefined;
